// eslint-disable-next-line no-undef
const configData = process.env;
const config = {};

try {
  config.apiURL =
    configData.REACT_APP_API_BASE_URI || "https://profile.srcm.net/";
  config.xClientIdSRCM =
    configData.REACT_APP_SRCM_XCLIENTID ||
    "wQEYuxIp3nKl6c93vhlLx9sEVFvEuEtKfH3tbA6W";
  config.keyCloakAuthConfig = {
    authUrl:
      process.env.REACT_APP_AUTH_URL || "https://hfnauth.qa.heartfulness.org",
    realm: process.env.REACT_APP_REALM || "heartfulness",
    client_id:
      process.env.REACT_APP_CLIENT_ID || "c8d091a5-32df-4bae-b45c-0bbceeb90485",
  };
} catch {
  config.apiURL = "https://profile.srcm.net/";
  config.keyCloakAuthConfig = {
    authUrl:
      process.env.REACT_APP_AUTH_URL || "https://hfnauth.qa.heartfulness.org",
    realm: process.env.REACT_APP_REALM || "heartfulness",
    client_id:
      process.env.REACT_APP_CLIENT_ID || "c8d091a5-32df-4bae-b45c-0bbceeb90485",
  };
}

config.maxAllowedFileSize = 20;
config.profileImageMaxFIleSize = 1;

config.cityAutoCompleteURL =
  configData.REACT_APP_AUTOCOMPLETE_API ||
  "https://us-central1-hfn-registration-qa.cloudfunctions.net/";
config.srcmStaticDataURL =
  configData.REACT_APP_STATIC_DATA_SRCM_URL ||
  "https://static-gatsby-qa.web.app/srcmapi/";

export default config;
